import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="var(--sds--ursa-icons--inner-shape-color, transparent)"
            d="M12.7 12.872a.7.7 0 1 1-1.4 0V8.597a.7.7 0 1 1 1.4 0zm-.7 3.231a.803.803 0 1 1 0-1.606.803.803 0 0 1 0 1.606"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0m9 1.572a.7.7 0 0 0 .7-.7V8.597a.7.7 0 1 0-1.4 0v4.275a.7.7 0 0 0 .7.7m-.803 1.728a.803.803 0 1 0 1.606 0 .803.803 0 0 0-1.606 0"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
